import { useMemo } from 'react';

interface UseOrderSubmitUnavailableLabelParams {
    unavailableItemCount: number;
    isManagerOrPMC: boolean;
    isRequiredPoNumberForOrder: boolean;
    hasLoadingPnA: boolean;
}

export const useOrderSubmitUnavailableLabel = ({
    unavailableItemCount,
    isManagerOrPMC,
    isRequiredPoNumberForOrder,
    hasLoadingPnA,
}: UseOrderSubmitUnavailableLabelParams) => {
    return useMemo(() => {
        const shouldShowUnavailableLabel =
            isManagerOrPMC &&
            unavailableItemCount > 0 &&
            !isRequiredPoNumberForOrder &&
            !hasLoadingPnA;

        return { unavailableItemCount, shouldShowUnavailableLabel };
    }, [
        unavailableItemCount,
        isManagerOrPMC,
        isRequiredPoNumberForOrder,
        hasLoadingPnA,
    ]);
};
